/* eslint no-console:0 */
import '../vitoria/stylesheets/layout.scss'

require.context('../base/images', true)
require.context('../vitoria/images', true)
require.context('../vitoria/videos', true)
// todo: unificar pastas de imagens em projetos que possuem componentes compartilhados
require.context('../images/vitoria', true)